import { useAuth } from "react-oidc-context";
import { useCallback, useState } from 'react';
import { clearAutomationDataFromLocalStorage } from "../utilities/getAutomationDataFromLocalStorage";


export function useLogoutHook(postLogoutUrl = '/') {
    const auth = useAuth();
    const [isLoading, setIsLoading] = useState(true);
    const logout = useCallback(async () => {
        clearAutomationDataFromLocalStorage();
        const id_token = auth.user.id_token;
        await auth.removeUser();
        await auth.signoutRedirect({
            extraQueryParams: {
                id_token_hint: id_token,
            }, state: { postLogoutRedirect: postLogoutUrl }
        });
        setIsLoading(false);
    }, [auth, postLogoutUrl]);

    return { logout, isLoading };
}